export default "__VITE_ASSET__B0v1kpQy__"